module.exports = __webpack_public_path__ + "static/media/order-success.08762cfb.png";